import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { reasonText } from "@/lib/sched";
import { AlertTriangle, XCircle } from "lucide-react";

export function ReasonList({ items, kind, t }) {
    if (!items?.length) return null;
    const warn = kind === "warning";
    return (
        <ul className={`space-y-1 rounded-lg p-3 text-sm ${warn ? "bg-amber-50 text-amber-900" : "bg-red-50 text-red-800"}`} data-testid={warn ? "warning-list" : "conflict-list"}>
            {items.map((r, i) => <li key={i} className="flex items-start gap-2">{warn ? <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" /> : <XCircle className="mt-0.5 h-4 w-4 shrink-0" />}{reasonText(t, r)}</li>)}
        </ul>
    );
}

export function WarningsDialog({ warnings, onCancel, onConfirm, confirmLabel, t }) {
    return (
        <Dialog open onOpenChange={(o) => !o && onCancel()}>
            <DialogContent className="max-w-md" data-testid="warnings-dialog">
                <DialogHeader><DialogTitle>{t("sched.warningsTitle")}</DialogTitle></DialogHeader>
                <ReasonList items={warnings} kind="warning" t={t} />
                <DialogFooter>
                    <Button variant="outline" onClick={onCancel} className="rounded-full" data-testid="warn-cancel">{t("sched.cancel")}</Button>
                    <Button onClick={onConfirm} className="rounded-full" data-testid="warn-confirm">{confirmLabel}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export function ChoiceDialog({ title, options, onCancel, t }) {
    return (
        <Dialog open onOpenChange={(o) => !o && onCancel()}>
            <DialogContent className="max-w-md" data-testid="choice-dialog">
                <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
                <div className="space-y-2">
                    {options.map((o, i) => (
                        <Button key={i} variant="outline" onClick={o.onSelect} className="w-full justify-start rounded-xl" data-testid={`choice-${i}`}>{o.label}</Button>
                    ))}
                </div>
                <DialogFooter><Button variant="ghost" onClick={onCancel} className="rounded-full">{t("sched.cancel")}</Button></DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
